import { useContext, useEffect } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import { GridWidgetsContext } from '../GridWidgetsContext';

export const useBoardResize = () => {
  const { boardHeight, onResizeBoardWidth } = useContext(GridWidgetsContext);

  const { width, ref } = useResizeDetector({
    handleHeight: false,
  });

  useEffect(() => {
    if (width) {
      onResizeBoardWidth({ width });
    }
  }, [width]);

  return { boardHeight, ref };
};
